module.exports = __webpack_public_path__ + "img/marker_proveedor.a34edf47.png";